import React from "react";

import { FaExclamationCircle } from "react-icons/fa";

import "../../global/components/Banner/banner.scss";

//this is a very rough draft of this prop and can be changed significantly as needed
//recommend passing in a title, list of paragraphs as props and passing into the render
//that would give us a fluid banner that we could stick wherever needed
//next step after that would be passing in a banner type and conditionally styling the banner
//also i'm not goot at writing nice css
export default class ProfilesBanner extends React.Component {
  render() {
    return (
      <div className="banner-info">
        <span className="banner-icon">
          <FaExclamationCircle color={"#000000"} size={30} />
        </span>
        <div className="banner-body">
          <p className="banner-body-item banner-body-item-last">
            If you have 50 or more entries for any single H-2A profile (e.g.,
            Agricultural Businesses, Crops or Commodities, Worker Housing, or
            Material Terms of Employment), please click{" "}
            <a href="/support/contact" target="_blank" rel="noopener">
              here
            </a>{" "}
            to submit a request for the FLAG Help Desk to upload, on your
            behalf, a data file into the H-2A profile of your FLAG Account.
            Please remember that this data upload service is only available to
            FLAG Account Holders who have 50 or more entries for any H-2A
            profile.
          </p>
        </div>
      </div>
    );
  }
}
